exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tree {\n  max-height: 250px;\n  overflow: auto; }\n\n.alert-header {\n  padding: 5px 10px;\n  background: #0f71d3; }\n\n.alert-header h2 {\n  line-height: normal;\n  font-size: 16px;\n  width: auto;\n  color: #fff;\n  float: left; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/shared/components/location-hierarchy/location-hierarchy.component.scss
// module id = 1463
// module chunks = 18